var map = {
	"./fire.mp3": 8055,
	"./flame-01.mp3": 1729,
	"./magic-dust.mp3": 3195,
	"./test-bird.mp3": 9436,
	"./test-drop.mp3": 3513,
	"./test-grab.mp3": 365,
	"./test-river.mp3": 3788,
	"./test-vial-drop.mp3": 7119,
	"./test-vial-full-drop.mp3": 445,
	"./test-vial-full-grab.mp3": 5385,
	"./test-vial-grab.mp3": 8342,
	"./tree-healing.mp3": 9743,
	"game-files/audio/sounds/fire.mp3": 8055,
	"game-files/audio/sounds/flame-01.mp3": 1729,
	"game-files/audio/sounds/magic-dust.mp3": 3195,
	"game-files/audio/sounds/test-bird.mp3": 9436,
	"game-files/audio/sounds/test-drop.mp3": 3513,
	"game-files/audio/sounds/test-grab.mp3": 365,
	"game-files/audio/sounds/test-river.mp3": 3788,
	"game-files/audio/sounds/test-vial-drop.mp3": 7119,
	"game-files/audio/sounds/test-vial-full-drop.mp3": 445,
	"game-files/audio/sounds/test-vial-full-grab.mp3": 5385,
	"game-files/audio/sounds/test-vial-grab.mp3": 8342,
	"game-files/audio/sounds/tree-healing.mp3": 9743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2974;